// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b2ff6af5","453":"1a76cc77"}[chunkId] + ".chunk.js";
};